import { onChange, store } from 'store';
import _isEqual from 'lodash/isEqual';
import eventEmitter from '../eventEmitter/EventEmitter';
import userRepository from '../repositories/UserRepository';

const userStore = {
  store: store({
    user: {},
    location: {
      cityName: '',
      cityLocation: '',
      countryCode: '',
      locationRegionCode: '',
      locationAccept: '',
    },
    authIssueId: '',
    isAuthorised: false,
  }),

  setLocation: (cityLocation: string): void => {
    userStore.store.location.cityLocation = cityLocation;
    userRepository.setCityLocation(cityLocation);
  },

  setCityName: (cityName: string): void => {
    userStore.store.location.cityName = cityName;
    userRepository.setCityName(cityName);
  },

  setCountryCode: (countryCode: string): void => {
    userStore.store.location.countryCode = countryCode;
    userRepository.setCountryCode(countryCode);
  },

  setRegionCode: (regionCode: string): void => {
    userStore.store.location.locationRegionCode = regionCode;
    userRepository.setRegionCode(regionCode);
  },

  setLocationAccept: (locationAccept: string): void => {
    userStore.store.location.locationAccept = locationAccept;
    userRepository.setLocationAccept(locationAccept);
  },

  setAuthorised: (value: boolean): void => {
    userStore.store.isAuthorised = value;
  },

  setAuthIssueId: (value: string): void => {
    userStore.store.authIssueId = value;
    userRepository.setAuthIssueId(value);
  },
};

onChange(userStore.store, (localStore: typeof userStore.store): void => {
  eventEmitter.emit('user-store-changed', localStore);
});

onChange(
  userStore.store,
  (localStore: typeof userStore.store): any => localStore.location,
  (...params) => !_isEqual(...params),
  (localStore: typeof userStore.store): void => {
    eventEmitter.emit('user-location-changed', localStore);
  },
);

onChange(
  userStore.store,
  (localStore: typeof userStore.store): any => localStore.isAuthorised,
  (...params) => !_isEqual(...params),
  (localStore: typeof userStore.store): void => {
    eventEmitter.emit('user-authorised-changed', localStore);
  },
);

onChange(
  userStore.store,
  (localStore: typeof userStore.store): any => localStore.user,
  (...params) => !_isEqual(...params),
  (localStore: typeof userStore.store): void => {
    eventEmitter.emit('user-changed', localStore);
  },
);

export const initLocation = (): void => {
  const cityLocation = userRepository.getCityLocation();
  const cityName = userRepository.getCityName();
  const countryCode = userRepository.getCountryCode();
  const regionCode = userRepository.getRegionCode();
  const authIssueId = userRepository.getAuthIssueId();

  if (cityLocation) {
    userStore.setLocation(cityLocation);
  }

  if (cityName) {
    userStore.setCityName(cityName);
  }

  if (countryCode) {
    userStore.setCountryCode(countryCode);
  }

  if (regionCode) {
    userStore.setRegionCode(regionCode);
  }

  if (authIssueId) {
    userStore.setAuthIssueId(authIssueId);
  }
};

export default userStore;
